const isEmptyObject = (obj) => {
  return !Object.keys(obj || {}).length
}

export default isEmptyObject
